import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isExternal(_ctx.to))
    ? (_openBlock(), _createBlock("a", {
        key: 0,
        href: _ctx.to,
        target: "_blank",
        rel: "noopener"
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 8, ["href"]))
    : (_openBlock(), _createBlock("div", {
        key: 1,
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.push && _ctx.push(...args)))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ]))
}